import { render, staticRenderFns } from "./teeConfig.vue?vue&type=template&id=50c70719"
import script from "./teeConfig.vue?vue&type=script&lang=js"
export * from "./teeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports